import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';
import { defineMessages, useIntl } from 'react-intl';

import { BrItem } from './BrItem';
import { SubstituteImage } from './SubstituteImage';

const messages = defineMessages({
  substituteSection: {
    id: 'person.substitute.section',
    defaultMessage: 'Substitute',
  },
});

export const Substitute = ({ person, isEditMode = false }) => {
  const intl = useIntl();
  if (!person.substituto) {
    return null;
  }

  const content = (
    <>
      <SubstituteImage substitute={person.substituto} />
      <span className="text-weight-medium text-up-01 flex-fill">
        {person.substituto.title}
      </span>
    </>
  );

  return (
    <>
      <span className="br-divider mt-2 mb-2"></span>
      <BrItem section={intl.formatMessage(messages.substituteSection)} />
      <MaybeWrap
        condition={isEditMode}
        as="div"
        className="br-item d-flex align-items-center gap-1 mb-2x"
      >
        <ConditionalLink
          to={person.substituto['@id']}
          condition={!isEditMode}
          className="br-item d-flex align-items-center gap-1 mb-2x"
        >
          {content}
        </ConditionalLink>
      </MaybeWrap>
    </>
  );
};
